import { ToastData } from 'context/ToastProvider/types';
import { usePortal } from 'hooks/usePortal';
import { useToast } from 'hooks/useToast';
import React from 'react';
import ReactDOM from 'react-dom';
import { Toast } from './Toast';
import { ToastsList } from './styled';

export const Toasts: React.FC<{ portalName: string }> = ({ portalName }) => {
  const { toasts, removeToast } = useToast();

  const portal = usePortal(portalName);

  if (!toasts?.length || !portal) return null;

  return ReactDOM.createPortal(
    <ToastsList data-testid="toasts-container">
      {toasts.map((toast: ToastData) => (
        <Toast key={toast.id} {...toast} removeToast={removeToast} />
      ))}
    </ToastsList>,
    portal
  );
};
